import * as React from "react"
import cs from "classnames"

import { GenericFormField } from "./Form"

import Autocomplete from "./Autocomplete/Autocomplete"
import TextField from "./TextField"
import CheckBox from "./CheckBox"
import CheckBoxes from "./CheckBoxes"
import Select from "./Select"
import Tags from "./Tags"
import DatePicker from "./DatePicker"
// import Locations from "./Locations"
import RichTextField from "./RichTextField"
import Radios from "./Radios"
import ButtonsSelector from "./ButtonsSelector"
import Switch from "./Switch"
import ColorPicker from "./ColorPicker"
import DateRangePicker from "./DateRangePicker"
import Files from "./Files"
import Slider from "./Slider"
import { PhoneInput } from "./PhoneInput"

import styles from "./Forms.module.scss"
import { PhoneInputWithPhoneNumbers } from "./PhoneInputWithPhoneNumbers"

interface Props {
  field: GenericFormField<any>
  className?: string
}

const ComponentMapping: Record<string, React.FC<any>> = {
  Autocomplete,
  TextField,
  DatePicker,
  CheckBox,
  CheckBoxes,
  Select,
  Tags,
  // Locations,
  RichTextField,
  Radios,
  ButtonsSelector,
  Switch,
  ColorPicker,
  DateRangePicker,
  Files,
  PhoneInput,
  PhoneInputWithPhoneNumbers,
  Slider,
}

export const GenericFormComponent = ({ field: { wrapperClassName, ...field }, className }: Props) => {
  let Component

  if (typeof field.component === "function") {
    Component = field.component
  } else {
    Component = ComponentMapping[field.component]
  }
  if (!Component) return null
  return (
    <div className={cs(wrapperClassName, { [styles.hidden]: field.hidden })}>
      {field.before}
      <Component {...field} className={cs(field.className, className)} key={field.name as string} />
      {field.after}
    </div>
  )
}
